module.exports = __webpack_public_path__ + "img/xingshancun.9ee8f507.png";